/* The is auto-generated file. Please don't touch it manually. */
/* eslint-disable quotes,max-lines,no-unused-vars */
// noinspection JSUnusedGlobalSymbols

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Any: any;
  Date: string;
  DateTime: string;
  Number: number;
  URL: string;
};

export type Account = {
  readonly active?: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['ID'];
  readonly image: Scalars['String'];
  readonly isTrial?: Maybe<Scalars['Boolean']>;
  readonly name: Scalars['String'];
  readonly readonly?: Maybe<Scalars['Boolean']>;
  readonly trial?: Maybe<AccountTrialSettings>;
};

export type AccountContact = {
  readonly __typename: 'AccountContact';
  readonly email: Scalars['String'];
  readonly name: Scalars['String'];
};

export enum AccountOrderByInput {
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC'
}

export type AccountTrialSettings = {
  readonly __typename: 'AccountTrialSettings';
  readonly endsIn?: Maybe<Scalars['Int']>;
  readonly status?: Maybe<AccountTrialStatus>;
};

export enum AccountTrialStatus {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED'
}

export type AccountsFeed = Feed & {
  readonly __typename: 'AccountsFeed';
  readonly accounts: ReadonlyArray<Account>;
  readonly count: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly total: Scalars['Int'];
};

export type Address = {
  readonly __typename: 'Address';
  readonly city?: Maybe<Scalars['String']>;
  readonly country: Scalars['String'];
  readonly postcode?: Maybe<Scalars['String']>;
  readonly province?: Maybe<Scalars['String']>;
  readonly street1?: Maybe<Scalars['String']>;
  readonly street2?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  readonly city: Scalars['String'];
  readonly country: Scalars['String'];
  readonly postcode?: InputMaybe<Scalars['String']>;
  readonly province?: InputMaybe<Scalars['String']>;
  readonly street1?: InputMaybe<Scalars['String']>;
  readonly street2?: InputMaybe<Scalars['String']>;
};

export type Admin = Account & {
  readonly __typename: 'Admin';
  readonly active?: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['ID'];
  readonly image: Scalars['String'];
  readonly isTrial?: Maybe<Scalars['Boolean']>;
  readonly name: Scalars['String'];
  readonly readonly?: Maybe<Scalars['Boolean']>;
  readonly trial?: Maybe<AccountTrialSettings>;
};

export type Attendance = {
  readonly __typename: 'Attendance';
  readonly attendeeId: Scalars['ID'];
  readonly eventFree: Scalars['Boolean'];
  readonly eventId: Scalars['ID'];
  readonly eventTitle: Scalars['String'];
  readonly paid: Scalars['Boolean'];
  readonly paidAmount: Scalars['Float'];
  readonly paidCurrency: Currency;
  readonly startDate: Scalars['String'];
  readonly status: AttendanceStatus;
};

export enum AttendanceStatus {
  CANCELLED = 'CANCELLED',
  PARTICIPATED = 'PARTICIPATED',
  REGISTERED = 'REGISTERED',
  TRANSFERRED = 'TRANSFERRED'
}

export type Attendee = {
  readonly __typename: 'Attendee';
  readonly bankCard?: Maybe<BankCard>;
  readonly billingAddress?: Maybe<Address>;
  readonly billingOrganization?: Maybe<Scalars['String']>;
  readonly billingTaxName?: Maybe<Scalars['String']>;
  readonly billingTaxNumber?: Maybe<Scalars['String']>;
  readonly birthDate?: Maybe<Scalars['Date']>;
  readonly certificate?: Maybe<Certificate>;
  readonly certificateId?: Maybe<Scalars['ID']>;
  readonly comment?: Maybe<Scalars['String']>;
  readonly company?: Maybe<Scalars['String']>;
  readonly companyAddress?: Maybe<Address>;
  readonly companyRole?: Maybe<Scalars['String']>;
  readonly consents?: Maybe<ReadonlyArray<Maybe<Consent>>>;
  readonly contact: Contact;
  readonly created?: Maybe<Scalars['DateTime']>;
  readonly customFields?: Maybe<ReadonlyArray<Maybe<CustomFieldValue>>>;
  readonly detailedPaidAmount: ReadonlyArray<OrderAmountLine>;
  readonly email: Scalars['String'];
  readonly evaluation?: Maybe<Evaluation>;
  readonly evaluationId?: Maybe<Scalars['ID']>;
  readonly evaluationUrl: Scalars['String'];
  readonly event: Event;
  readonly eventId: Scalars['ID'];
  readonly generateCertificateState: GenerateCertificateState;
  readonly homeAddress?: Maybe<Address>;
  readonly id: Scalars['ID'];
  readonly isPaid: Scalars['Boolean'];
  readonly memberId?: Maybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly paidAmount?: Maybe<Scalars['Float']>;
  readonly paidCurrency?: Maybe<Currency>;
  readonly paymentMethod: PaymentMethod;
  readonly permissions?: Maybe<ReadonlyArray<Maybe<AttendeePermission>>>;
  readonly phone?: Maybe<Scalars['String']>;
  readonly promoCode?: Maybe<Scalars['String']>;
  readonly referral?: Maybe<Scalars['String']>;
  readonly source: Scalars['String'];
  readonly status: AttendanceStatus;
  readonly ticketType?: Maybe<TicketType>;
  readonly ticketTypeId?: Maybe<Scalars['ID']>;
};

export type AttendeeFeed = Feed & {
  readonly __typename: 'AttendeeFeed';
  readonly attendees: ReadonlyArray<Attendee>;
  readonly count: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly total: Scalars['Int'];
};

export type AttendeeInput = {
  readonly billingAddress?: InputMaybe<AddressInput>;
  readonly billingINN?: InputMaybe<Scalars['String']>;
  readonly billingOrganization?: InputMaybe<Scalars['String']>;
  readonly birthDate?: InputMaybe<Scalars['Date']>;
  readonly company?: InputMaybe<Scalars['String']>;
  readonly companyAddress?: InputMaybe<AddressInput>;
  readonly companyRole?: InputMaybe<Scalars['String']>;
  readonly email?: InputMaybe<Scalars['String']>;
  readonly homeAddress?: InputMaybe<AddressInput>;
  readonly isPaid?: InputMaybe<Scalars['Boolean']>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly paidAmount?: InputMaybe<Scalars['Float']>;
  readonly paidCurrency?: InputMaybe<Currency>;
  readonly phone?: InputMaybe<Scalars['String']>;
  readonly ticketId?: InputMaybe<Scalars['ID']>;
};

export enum AttendeeOrderByInput {
  created_asc = 'created_asc',
  created_desc = 'created_desc',
  name_asc = 'name_asc',
  name_desc = 'name_desc'
}

export enum AttendeePermission {
  Delete = 'Delete',
  Edit = 'Edit',
  Full = 'Full',
  GenerateCertificate = 'GenerateCertificate',
  ManageEvaluation = 'ManageEvaluation',
  Read = 'Read',
  Subscribe = 'Subscribe',
  UpdateContact = 'UpdateContact',
  UpdateParticipation = 'UpdateParticipation',
  UpdatePayment = 'UpdatePayment'
}

export type Badge = {
  readonly __typename: 'Badge';
  readonly id: Scalars['ID'];
  readonly image: Scalars['String'];
  readonly name: Scalars['String'];
  readonly thumbnail?: Maybe<Scalars['String']>;
};

export type BankCard = {
  readonly __typename: 'BankCard';
  readonly brand: Scalars['String'];
  readonly last4: Scalars['String'];
};

export enum BeforeAfter {
  After = 'After',
  Before = 'Before'
}

export type BillingAddress = {
  readonly __typename: 'BillingAddress';
  readonly city?: Maybe<Scalars['String']>;
  readonly country: Scalars['String'];
  readonly name: Scalars['String'];
  readonly postcode?: Maybe<Scalars['String']>;
  readonly province?: Maybe<Scalars['String']>;
  readonly street1?: Maybe<Scalars['String']>;
  readonly street2?: Maybe<Scalars['String']>;
  readonly taxNumber?: Maybe<Scalars['String']>;
};

export type Brand = Account & {
  readonly __typename: 'Brand';
  readonly active?: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['ID'];
  readonly image: Scalars['String'];
  readonly isTrial?: Maybe<Scalars['Boolean']>;
  readonly name: Scalars['String'];
  readonly readonly?: Maybe<Scalars['Boolean']>;
  readonly trial?: Maybe<AccountTrialSettings>;
};

export type BrandCompanyAddInput = {
  readonly company: CompanyInput;
  readonly licenseEndDate: Scalars['Date'];
  readonly licenseFee: MoneyInput;
  readonly licenseSeats: Scalars['Int'];
  readonly licenseStartDate: Scalars['Date'];
  readonly licenseTypeId: Scalars['ID'];
  readonly licenseVersion: Scalars['String'];
};

export type BrandInvoice = {
  readonly __typename: 'BrandInvoice';
  readonly address?: Maybe<Address>;
  readonly amount: Money;
  readonly date: Scalars['Date'];
  readonly description: Scalars['String'];
  readonly eventId: Scalars['ID'];
  readonly id: Scalars['ID'];
  readonly organisation?: Maybe<Scalars['String']>;
  readonly remoteId?: Maybe<Scalars['String']>;
  readonly sentDate?: Maybe<Scalars['Date']>;
  readonly state: InvoiceState;
  readonly taxId?: Maybe<Scalars['String']>;
  readonly to: AccountContact;
};

export type BrandInvoiceInput = {
  readonly remoteId?: InputMaybe<Scalars['String']>;
  readonly sentDate?: InputMaybe<Scalars['Date']>;
  readonly state: InvoiceState;
};

export type BrandInvoiceStatistics = {
  readonly __typename: 'BrandInvoiceStatistics';
  readonly final: Scalars['Number'];
  readonly paid: Scalars['Number'];
  readonly review: Scalars['Number'];
  readonly total: Scalars['Number'];
};

export type BrandMonthlyPaidStatistics = {
  readonly __typename: 'BrandMonthlyPaidStatistics';
  readonly amount: Scalars['Number'];
  readonly currency: Scalars['String'];
  readonly month: Scalars['String'];
};

export type Category = {
  readonly __typename: 'Category';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly types: ReadonlyArray<Maybe<EventType>>;
  readonly version: CategoryVersion;
};

export type CategoryAccess = {
  readonly __typename: 'CategoryAccess';
  readonly active: Scalars['Boolean'];
  readonly categoryId: Scalars['ID'];
  readonly id: Scalars['ID'];
  readonly licenseeId: Scalars['ID'];
  readonly limited: Scalars['Boolean'];
};

export enum CategoryVersion {
  V1_0 = 'V1_0',
  V1_5 = 'V1_5',
  V2_0 = 'V2_0'
}

export type Certificate = {
  readonly __typename: 'Certificate';
  readonly generating: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly url: Scalars['URL'];
};

export type CheckboxInput = {
  readonly label: Scalars['String'];
  readonly labels: ReadonlyArray<TranslatedWordInput>;
  readonly sectionId: Scalars['String'];
};

export type Company = {
  readonly __typename: 'Company';
  readonly address: Address;
  readonly avatar?: Maybe<Scalars['String']>;
  readonly description?: Maybe<Scalars['String']>;
  readonly email: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
};

export type CompanyAccount = Account & {
  readonly __typename: 'CompanyAccount';
  readonly active?: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['ID'];
  readonly image: Scalars['String'];
  readonly isTrial?: Maybe<Scalars['Boolean']>;
  readonly name: Scalars['String'];
  readonly readonly?: Maybe<Scalars['Boolean']>;
  readonly trial?: Maybe<AccountTrialSettings>;
};

export type CompanyInput = {
  readonly contact: CustomerContactInput;
  readonly country: Scalars['String'];
  readonly description?: InputMaybe<Scalars['String']>;
  readonly name: Scalars['String'];
};

export type CompanyManagerInput = {
  readonly companyId: Scalars['ID'];
  readonly email: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly lastName: Scalars['String'];
};

export type Configuration = {
  readonly __typename: 'Configuration';
  readonly publicStripeKey: Scalars['String'];
};

export type Consent = {
  readonly __typename: 'Consent';
  readonly accepted: Scalars['Boolean'];
  readonly acceptedAt: Scalars['DateTime'];
  readonly content: Scalars['String'];
};

export enum ConsentForTestimonial {
  Given = 'Given',
  NotGiven = 'NotGiven',
  Unknown = 'Unknown'
}

export type Contact = {
  readonly __typename: 'Contact';
  readonly address?: Maybe<Address>;
  readonly attendance: ReadonlyArray<Attendance>;
  readonly email: Scalars['String'];
  readonly emails: ReadonlyArray<Scalars['String']>;
  readonly events: Scalars['Int'];
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly type: ContactType;
  readonly visible: Scalars['Boolean'];
};

export type ContactFeed = Feed & {
  readonly __typename: 'ContactFeed';
  readonly contacts: ReadonlyArray<Contact>;
  readonly count: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly total: Scalars['Int'];
};

export enum ContactOrderByInput {
  events_asc = 'events_asc',
  events_desc = 'events_desc',
  name_asc = 'name_asc',
  name_desc = 'name_desc'
}

export enum ContactType {
  Company = 'Company',
  Person = 'Person'
}

export type ContentSection = {
  readonly __typename: 'ContentSection';
  readonly label: Scalars['String'];
  readonly replies: ReadonlyArray<Reply>;
};

export enum Currency {
  AED = 'AED',
  ARS = 'ARS',
  AUD = 'AUD',
  BOB = 'BOB',
  BRL = 'BRL',
  BYN = 'BYN',
  CAD = 'CAD',
  CHF = 'CHF',
  CLP = 'CLP',
  CNY = 'CNY',
  COP = 'COP',
  CRC = 'CRC',
  CZK = 'CZK',
  DKK = 'DKK',
  DOP = 'DOP',
  EUR = 'EUR',
  GBP = 'GBP',
  GEL = 'GEL',
  GTQ = 'GTQ',
  HKD = 'HKD',
  HNL = 'HNL',
  HUF = 'HUF',
  INR = 'INR',
  ISK = 'ISK',
  JPY = 'JPY',
  KRW = 'KRW',
  MAD = 'MAD',
  MUR = 'MUR',
  MXN = 'MXN',
  MYR = 'MYR',
  NIO = 'NIO',
  NOK = 'NOK',
  NZD = 'NZD',
  PAB = 'PAB',
  PEN = 'PEN',
  PLN = 'PLN',
  PYG = 'PYG',
  RON = 'RON',
  RUB = 'RUB',
  SEK = 'SEK',
  SGD = 'SGD',
  SVC = 'SVC',
  THB = 'THB',
  TND = 'TND',
  TRY = 'TRY',
  TWD = 'TWD',
  UAH = 'UAH',
  USD = 'USD',
  UYU = 'UYU',
  VEF = 'VEF',
  CFA = 'CFA',
  ZAR = 'ZAR'
}

export type CustomField = {
  readonly __typename: 'CustomField';
  readonly choices?: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly id: Scalars['ID'];
  readonly label: Scalars['String'];
  readonly required: Scalars['Boolean'];
  readonly type: CustomFieldType;
};

export enum CustomFieldType {
  CHECKBOX = 'CHECKBOX',
  CHOICES = 'CHOICES',
  DATE = 'DATE',
  NUMBER = 'NUMBER',
  TEXT = 'TEXT'
}

export type CustomFieldValue = {
  readonly __typename: 'CustomFieldValue';
  readonly label: Scalars['String'];
  readonly value?: Maybe<Scalars['Any']>;
};

export type CustomerContact = {
  readonly __typename: 'CustomerContact';
  readonly email: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly lastName: Scalars['String'];
};

export type CustomerContactInput = {
  readonly email: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly lastName: Scalars['String'];
};

export type DashboardNotification = {
  readonly __typename: 'DashboardNotification';
  readonly id: Scalars['ID'];
  readonly type: Scalars['String'];
  readonly visible: Scalars['Boolean'];
};

export type DropdownField = Field & {
  readonly __typename: 'DropdownField';
  readonly id: Scalars['ID'];
  readonly label: Scalars['String'];
  readonly labels: ReadonlyArray<TranslatedWord>;
  readonly options: ReadonlyArray<TranslatedOptions>;
  readonly sectionId: Scalars['ID'];
  readonly type: FieldType;
};

export type DropdownInput = {
  readonly label: Scalars['String'];
  readonly labels: ReadonlyArray<TranslatedWordInput>;
  readonly options: ReadonlyArray<TranslatedOptionInput>;
  readonly sectionId: Scalars['String'];
};

export enum EditingRights {
  Full = 'Full',
  Limited = 'Limited',
  ReadOnly = 'ReadOnly'
}

export type EmailMessageInput = {
  readonly attendeeId: Scalars['ID'];
  readonly body: Scalars['String'];
  readonly subject: Scalars['String'];
  readonly test: Scalars['Boolean'];
};

export type EmailNotificationTemplate = {
  readonly __typename: 'EmailNotificationTemplate';
  readonly body: Scalars['String'];
  readonly conditions: SendingConditions;
  readonly enabled: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly subject: Scalars['String'];
};

export type EmailNotificationTemplateInput = {
  readonly body: Scalars['String'];
  readonly conditions: SendingConditionsInput;
  readonly name: Scalars['String'];
  readonly subject: Scalars['String'];
};

export enum EmailTemplateType {
  account_event = 'account_event',
  license_type = 'license_type'
}

export type Evaluation = {
  readonly __typename: 'Evaluation';
  readonly approved: Scalars['Boolean'];
  readonly attendee: Attendee;
  readonly consent: ConsentForTestimonial;
  readonly content: ReadonlyArray<ContentSection>;
  readonly created: Scalars['DateTime'];
  readonly event: Event;
  readonly id: Scalars['ID'];
  readonly rating: Scalars['Int'];
  readonly review: Scalars['String'];
  readonly testimonial: Scalars['Boolean'];
};

export type EvaluationFeed = Feed & {
  readonly __typename: 'EvaluationFeed';
  readonly count: Scalars['Int'];
  readonly items: ReadonlyArray<Evaluation>;
  readonly skip: Scalars['Int'];
  readonly total: Scalars['Int'];
};

export type EvaluationFormConfiguration = {
  readonly __typename: 'EvaluationFormConfiguration';
  readonly editingRights: EditingRights;
  readonly id: Scalars['ID'];
  readonly rules: FormConfigurationRules;
  readonly sections: ReadonlyArray<SectionSkeleton>;
};

export type EvaluationFormConfigurationInput = {
  readonly rules: FormConfigurationRulesInput;
  readonly sections: ReadonlyArray<SectionSkeletonInput>;
};

export enum EvaluationOrderByInput {
  created_asc = 'created_asc',
  created_desc = 'created_desc'
}

export type Event = {
  readonly __typename: 'Event';
  readonly confirmed: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly isFree: Scalars['Boolean'];
  readonly location: EventLocation;
  readonly schedule: EventSchedule;
  readonly statistics: EventStatistics;
  readonly title: Scalars['String'];
  readonly trainers: ReadonlyArray<Trainer>;
};

export type EventInvoice = {
  readonly __typename: 'EventInvoice';
  readonly amount: Scalars['String'];
  readonly clientStripeId?: Maybe<Scalars['String']>;
  readonly daysOverdue: Scalars['Number'];
  readonly eventId: Scalars['ID'];
  readonly payable: Scalars['Boolean'];
  readonly sentDate: Scalars['Date'];
  readonly title: Scalars['String'];
};

export type EventInvoiceFeed = Feed & {
  readonly __typename: 'EventInvoiceFeed';
  readonly count: Scalars['Int'];
  readonly items: ReadonlyArray<EventInvoice>;
  readonly skip: Scalars['Int'];
  readonly total: Scalars['Int'];
};

export type EventLocation = {
  readonly __typename: 'EventLocation';
  readonly city?: Maybe<Scalars['String']>;
  readonly country: Scalars['String'];
  readonly online: Scalars['Boolean'];
};

export enum EventOrderByInput {
  start_asc = 'start_asc',
  start_desc = 'start_desc',
  title_asc = 'title_asc',
  title_desc = 'title_desc'
}

export type EventSchedule = {
  readonly __typename: 'EventSchedule';
  readonly end: Scalars['DateTime'];
  readonly start: Scalars['DateTime'];
  readonly status: ScheduleStatus;
  readonly timezone?: Maybe<Scalars['String']>;
};

export type EventStatistics = {
  readonly __typename: 'EventStatistics';
  readonly certificates: Scalars['Number'];
  readonly evaluations: Scalars['Number'];
  readonly soldTickets: Scalars['Number'];
  readonly students: Scalars['Number'];
};

export type EventType = {
  readonly __typename: 'EventType';
  readonly active: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly withModules: Scalars['Boolean'];
};

export type EventTypeAccess = {
  readonly __typename: 'EventTypeAccess';
  readonly categoryId: Scalars['ID'];
  readonly eventTypeId: Scalars['ID'];
  readonly licenseeId: Scalars['ID'];
};

export type EventsFeed = Feed & {
  readonly __typename: 'EventsFeed';
  readonly count: Scalars['Int'];
  readonly events: ReadonlyArray<Event>;
  readonly skip: Scalars['Int'];
  readonly total: Scalars['Int'];
};

export type Feed = {
  readonly count: Scalars['Int'];
  readonly skip: Scalars['Int'];
  readonly total: Scalars['Int'];
};

export type Field = {
  readonly id: Scalars['ID'];
  readonly label: Scalars['String'];
  readonly labels: ReadonlyArray<TranslatedWord>;
  readonly sectionId: Scalars['ID'];
  readonly type: FieldType;
};

export type FieldConfiguration = {
  readonly __typename: 'FieldConfiguration';
  readonly editable: Scalars['Boolean'];
  readonly field: PossibleField;
  readonly id: Scalars['ID'];
  readonly locked: Scalars['Boolean'];
  readonly required: Scalars['Boolean'];
};

export type FieldSkeleton = {
  readonly __typename: 'FieldSkeleton';
  readonly id: Scalars['ID'];
  readonly required: Scalars['Boolean'];
};

export type FieldSkeletonInput = {
  readonly id: Scalars['ID'];
  readonly required: Scalars['Boolean'];
};

export enum FieldType {
  Checkbox = 'Checkbox',
  Dropdown = 'Dropdown',
  Text = 'Text',
  TextArea = 'TextArea'
}

export type FormConfigurationRules = {
  readonly __typename: 'FormConfigurationRules';
  readonly defaultLanguage: Scalars['String'];
  readonly eventTypeIds: ReadonlyArray<Scalars['ID']>;
  readonly freePaidStatus: FreePaidStatus;
  readonly privatePublicStatus: PrivatePublicStatus;
};

export type FormConfigurationRulesInput = {
  readonly defaultLanguage: Scalars['String'];
  readonly eventTypeIds: ReadonlyArray<InputMaybe<Scalars['ID']>>;
  readonly freePaidStatus: FreePaidStatus;
  readonly privatePublicStatus: PrivatePublicStatus;
};

export enum FormType {
  EvaluationFormType = 'EvaluationFormType',
  RegistrationFormType = 'RegistrationFormType'
}

export enum FreePaidStatus {
  FreePaid = 'FreePaid',
  OnlyFree = 'OnlyFree',
  OnlyPaid = 'OnlyPaid'
}

export enum GenerateCertificateState {
  FAIL_EVENT_NOT_CONFIRMED = 'FAIL_EVENT_NOT_CONFIRMED',
  FAIL_EVENT_NOT_STARTED = 'FAIL_EVENT_NOT_STARTED',
  FAIL_EVENT_NO_CERTIFICATE = 'FAIL_EVENT_NO_CERTIFICATE',
  FAIL_NOT_PARTICIPATED = 'FAIL_NOT_PARTICIPATED',
  FAIL_NO_EVALUATION = 'FAIL_NO_EVALUATION',
  NOT_EXPECTED = 'NOT_EXPECTED',
  OK = 'OK'
}

export type InvoiceFeed = Feed & {
  readonly __typename: 'InvoiceFeed';
  readonly count: Scalars['Int'];
  readonly items: ReadonlyArray<BrandInvoice>;
  readonly skip: Scalars['Int'];
  readonly total: Scalars['Int'];
};

export enum InvoiceOrderByInput {
  date_asc = 'date_asc',
  date_desc = 'date_desc'
}

export enum InvoiceState {
  cancelled = 'cancelled',
  draft = 'draft',
  final = 'final',
  paid = 'paid',
  review = 'review'
}

export type LearningModule = {
  readonly __typename: 'LearningModule';
  readonly active: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly used: Scalars['Boolean'];
};

export type LearningModuleInput = {
  readonly name: Scalars['String'];
};

export type License = {
  readonly __typename: 'License';
  readonly active: Scalars['Boolean'];
  readonly amount: Scalars['Float'];
  readonly continuousRenewal: Scalars['Boolean'];
  readonly currency: Currency;
  readonly expired: Scalars['Boolean'];
  readonly expiresAt: Scalars['Date'];
  readonly expiresIn: Scalars['Int'];
  readonly id: Scalars['ID'];
  readonly licensee: Licensee;
  readonly periods: ReadonlyArray<SubscriptionPeriod>;
  readonly seats: Scalars['Int'];
  readonly typeId: Scalars['ID'];
  readonly version: Scalars['String'];
};

export type LicenseAgreement = {
  readonly __typename: 'LicenseAgreement';
  readonly consent: Scalars['String'];
  readonly content: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly version: Scalars['String'];
};

export type LicenseAgreementInput = {
  readonly consent: Scalars['String'];
  readonly content: Scalars['String'];
  readonly licenseTypeId: Scalars['ID'];
  readonly version: Scalars['String'];
};

export type LicenseFeed = Feed & {
  readonly __typename: 'LicenseFeed';
  readonly count: Scalars['Int'];
  readonly licenses: ReadonlyArray<License>;
  readonly skip: Scalars['Int'];
  readonly total: Scalars['Int'];
};

export type LicenseType = {
  readonly __typename: 'LicenseType';
  readonly active: Scalars['Boolean'];
  readonly agreement?: Maybe<LicenseAgreement>;
  readonly eventTypes: ReadonlyArray<EventType>;
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly parentLicenseTypeId?: Maybe<Scalars['ID']>;
  readonly renewalNotifications: ReadonlyArray<EmailNotificationTemplate>;
  readonly renewalPeriod?: Maybe<Scalars['Int']>;
  readonly tags: ReadonlyArray<Scalars['String']>;
};

export type LicenseTypeInput = {
  readonly name: Scalars['String'];
  readonly tags: ReadonlyArray<Scalars['String']>;
  readonly typeIds: ReadonlyArray<Scalars['ID']>;
};

export type Licensee = {
  readonly __typename: 'Licensee';
  readonly address: Address;
  readonly avatar?: Maybe<Scalars['String']>;
  readonly billingAddresses: ReadonlyArray<BillingAddress>;
  readonly company?: Maybe<Company>;
  readonly contact?: Maybe<CustomerContact>;
  readonly email: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly trainer?: Maybe<Trainer>;
  readonly type: LicenseeType;
};

export enum LicenseeOrderByInput {
  country_asc = 'country_asc',
  country_desc = 'country_desc',
  expired_at_asc = 'expired_at_asc',
  expired_at_desc = 'expired_at_desc',
  joined_asc = 'joined_asc',
  joined_desc = 'joined_desc',
  name_asc = 'name_asc',
  name_desc = 'name_desc'
}

export enum LicenseeType {
  Company = 'Company',
  Trainer = 'Trainer'
}

export type LicenseesFeed = Feed & {
  readonly __typename: 'LicenseesFeed';
  readonly count: Scalars['Int'];
  readonly licensees: ReadonlyArray<License>;
  readonly skip: Scalars['Int'];
  readonly total: Scalars['Int'];
};

export type Manager = {
  readonly __typename: 'Manager';
  readonly avatar?: Maybe<Scalars['String']>;
  readonly email: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly lastName: Scalars['String'];
  readonly name: Scalars['String'];
};

export type Money = {
  readonly __typename: 'Money';
  readonly amount: Scalars['Float'];
  readonly currency: Currency;
};

export type MoneyInput = {
  readonly amount: Scalars['Float'];
  readonly currency: Currency;
};

export type Mutation = {
  readonly __typename: 'Mutation';
  readonly addEmailTemplate: EmailNotificationTemplate;
  readonly addLicenseeBadge: Scalars['Boolean'];
  readonly addSubLicense: License;
  readonly approveEvaluation?: Maybe<Evaluation>;
  readonly changeAttendeeParticipationStatus?: Maybe<Attendee>;
  readonly changeAttendeePaymentStatus?: Maybe<Attendee>;
  readonly closeOpenPlatformInvoices?: Maybe<Scalars['Int']>;
  readonly companyManager?: Maybe<Manager>;
  readonly createCheckboxField?: Maybe<FieldConfiguration>;
  readonly createCompany?: Maybe<Account>;
  readonly createCompanyManager?: Maybe<Manager>;
  readonly createDropdownField?: Maybe<FieldConfiguration>;
  readonly createEvaluationFormConfiguration: EvaluationFormConfiguration;
  readonly createLicenseAgreement: LicenseAgreement;
  readonly createLicenseType: LicenseType;
  readonly createLicenseeCompany: Licensee;
  readonly createModule: LearningModule;
  readonly createPercentRatingField?: Maybe<FieldConfiguration>;
  readonly createRatingField?: Maybe<FieldConfiguration>;
  readonly createRegistrationFormConfiguration: RegistrationFormConfiguration;
  readonly createSection?: Maybe<SectionConfiguration>;
  readonly createStarRatingField?: Maybe<FieldConfiguration>;
  readonly createTestimonial?: Maybe<Evaluation>;
  readonly createTextAreaField?: Maybe<FieldConfiguration>;
  readonly createTextField?: Maybe<FieldConfiguration>;
  readonly deleteAttendee?: Maybe<Attendee>;
  readonly deleteCompanyManager?: Maybe<Manager>;
  readonly deleteContact: Contact;
  readonly deleteEmailTemplate: EmailNotificationTemplate;
  readonly deleteEvaluation?: Maybe<Evaluation>;
  readonly deleteField?: Maybe<FieldConfiguration>;
  readonly deleteLicense: Scalars['Boolean'];
  readonly deleteLicenseAgreement: LicenseAgreement;
  readonly deleteLicenseType: LicenseType;
  readonly deleteModule: LearningModule;
  readonly deleteSection?: Maybe<SectionConfiguration>;
  readonly dismissDashboardNotification?: Maybe<DashboardNotification>;
  readonly exportBrandInvoices?: Maybe<Scalars['Boolean']>;
  readonly generateCertificate?: Maybe<Certificate>;
  readonly mergeContact: Contact;
  readonly rebuildEvents?: Maybe<Scalars['Int']>;
  readonly removeLicenseeBadge: Scalars['Boolean'];
  readonly removeTestimonial?: Maybe<Evaluation>;
  readonly reportExportAttendees?: Maybe<Scalars['Boolean']>;
  readonly reportExportEvents?: Maybe<Scalars['Boolean']>;
  readonly resendCertificate?: Maybe<Certificate>;
  readonly revokeSubLicense: License;
  readonly sendEmail?: Maybe<Scalars['Boolean']>;
  readonly sendTestEmail?: Maybe<Scalars['Boolean']>;
  readonly toggleContactVisibility: Contact;
  readonly toggleEventTypeAccess?: Maybe<EventTypeAccess>;
  readonly toggleLicenseType: LicenseType;
  readonly toggleLicenseeAccess: CategoryAccess;
  readonly toggleModule: LearningModule;
  readonly toggleModuleStatus: EventType;
  readonly transferAttendee?: Maybe<Attendee>;
  readonly updateCheckboxField?: Maybe<FieldConfiguration>;
  readonly updateCompanyManager?: Maybe<Manager>;
  readonly updateDropdownField?: Maybe<FieldConfiguration>;
  readonly updateEmailTemplate: EmailNotificationTemplate;
  readonly updateEvaluationFormConfiguration: EvaluationFormConfiguration;
  readonly updateInvoice: BrandInvoice;
  readonly updateLicenseAgreement: LicenseAgreement;
  readonly updateLicenseType: LicenseType;
  readonly updateLicenseeCompany: Scalars['ID'];
  readonly updateModule: LearningModule;
  readonly updatePercentRatingField?: Maybe<FieldConfiguration>;
  readonly updateRatingField?: Maybe<FieldConfiguration>;
  readonly updateRegistrationFormConfiguration: RegistrationFormConfiguration;
  readonly updateRenewalPeriod: LicenseType;
  readonly updateSection?: Maybe<SectionConfiguration>;
  readonly updateStarRatingField?: Maybe<FieldConfiguration>;
  readonly updateTextAreaField?: Maybe<FieldConfiguration>;
  readonly updateTextField?: Maybe<FieldConfiguration>;
  readonly useAccount?: Maybe<Account>;
};


export type MutationAddEmailTemplateArgs = {
  data: EmailNotificationTemplateInput;
  objectId: Scalars['ID'];
  objectType: EmailTemplateType;
};


export type MutationAddLicenseeBadgeArgs = {
  badgeId: Scalars['ID'];
  licenseeId: Scalars['ID'];
};


export type MutationAddSubLicenseArgs = {
  parentLicenseId: Scalars['ID'];
  trainerId: Scalars['ID'];
};


export type MutationApproveEvaluationArgs = {
  evaluationId: Scalars['ID'];
};


export type MutationChangeAttendeeParticipationStatusArgs = {
  attendeeId: Scalars['ID'];
  status: AttendanceStatus;
};


export type MutationChangeAttendeePaymentStatusArgs = {
  attendeeId: Scalars['ID'];
  paid: Scalars['Boolean'];
};


export type MutationCompanyManagerArgs = {
  companyId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationCreateCheckboxFieldArgs = {
  data: CheckboxInput;
  type: FormType;
};


export type MutationCreateCompanyArgs = {
  data: CompanyInput;
};


export type MutationCreateCompanyManagerArgs = {
  data: CompanyManagerInput;
};


export type MutationCreateDropdownFieldArgs = {
  data: DropdownInput;
  type: FormType;
};


export type MutationCreateEvaluationFormConfigurationArgs = {
  data?: InputMaybe<EvaluationFormConfigurationInput>;
};


export type MutationCreateLicenseAgreementArgs = {
  data: LicenseAgreementInput;
  licenseTypeId: Scalars['ID'];
};


export type MutationCreateLicenseTypeArgs = {
  data?: InputMaybe<LicenseTypeInput>;
};


export type MutationCreateLicenseeCompanyArgs = {
  data: BrandCompanyAddInput;
};


export type MutationCreateModuleArgs = {
  data?: InputMaybe<LearningModuleInput>;
};


export type MutationCreatePercentRatingFieldArgs = {
  data: PercentRatingInput;
  type: FormType;
};


export type MutationCreateRatingFieldArgs = {
  data: RatingInput;
  type: FormType;
};


export type MutationCreateRegistrationFormConfigurationArgs = {
  data?: InputMaybe<RegistrationFormConfigurationInput>;
};


export type MutationCreateSectionArgs = {
  data: SectionInput;
  type: FormType;
};


export type MutationCreateStarRatingFieldArgs = {
  data: StarRatingInput;
  type: FormType;
};


export type MutationCreateTestimonialArgs = {
  evaluationId: Scalars['ID'];
};


export type MutationCreateTextAreaFieldArgs = {
  data: TextAreaInput;
  type: FormType;
};


export type MutationCreateTextFieldArgs = {
  data: TextInput;
  type: FormType;
};


export type MutationDeleteAttendeeArgs = {
  attendeeId: Scalars['ID'];
};


export type MutationDeleteCompanyManagerArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteContactArgs = {
  contactId: Scalars['ID'];
};


export type MutationDeleteEmailTemplateArgs = {
  id: Scalars['ID'];
  objectId: Scalars['ID'];
  objectType: EmailTemplateType;
};


export type MutationDeleteEvaluationArgs = {
  evaluationId: Scalars['ID'];
};


export type MutationDeleteFieldArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteLicenseArgs = {
  licenseId: Scalars['ID'];
};


export type MutationDeleteLicenseAgreementArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteLicenseTypeArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteModuleArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSectionArgs = {
  id: Scalars['ID'];
};


export type MutationDismissDashboardNotificationArgs = {
  id: Scalars['ID'];
};


export type MutationExportBrandInvoicesArgs = {
  fields: ReadonlyArray<Scalars['String']>;
  filterByState?: InputMaybe<Scalars['String']>;
  orderBy: InvoiceOrderByInput;
  searchBy?: InputMaybe<Scalars['String']>;
};


export type MutationGenerateCertificateArgs = {
  attendeeId: Scalars['ID'];
  send?: InputMaybe<Scalars['Boolean']>;
};


export type MutationMergeContactArgs = {
  from: Scalars['ID'];
  to: Scalars['ID'];
};


export type MutationRemoveLicenseeBadgeArgs = {
  badgeId: Scalars['ID'];
  licenseeId: Scalars['ID'];
};


export type MutationRemoveTestimonialArgs = {
  evaluationId: Scalars['ID'];
};


export type MutationReportExportAttendeesArgs = {
  fields: ReadonlyArray<Scalars['String']>;
};


export type MutationReportExportEventsArgs = {
  fields: ReadonlyArray<Scalars['String']>;
};


export type MutationResendCertificateArgs = {
  attendeeId: Scalars['ID'];
};


export type MutationRevokeSubLicenseArgs = {
  licenseId: Scalars['ID'];
  parentLicenseId: Scalars['ID'];
};


export type MutationSendEmailArgs = {
  message: EmailMessageInput;
};


export type MutationSendTestEmailArgs = {
  message: EmailMessageInput;
};


export type MutationToggleContactVisibilityArgs = {
  contactId: Scalars['ID'];
};


export type MutationToggleEventTypeAccessArgs = {
  eventTypeId: Scalars['ID'];
  licenseeId: Scalars['ID'];
};


export type MutationToggleLicenseTypeArgs = {
  id: Scalars['ID'];
};


export type MutationToggleLicenseeAccessArgs = {
  licenseeId: Scalars['ID'];
};


export type MutationToggleModuleArgs = {
  id: Scalars['ID'];
};


export type MutationToggleModuleStatusArgs = {
  id: Scalars['ID'];
};


export type MutationTransferAttendeeArgs = {
  attendeeId: Scalars['ID'];
  eventId: Scalars['ID'];
  sendWelcomeEmail: Scalars['Boolean'];
};


export type MutationUpdateCheckboxFieldArgs = {
  data: CheckboxInput;
  id: Scalars['ID'];
  type: FormType;
};


export type MutationUpdateCompanyManagerArgs = {
  data: CompanyManagerInput;
  id: Scalars['ID'];
};


export type MutationUpdateDropdownFieldArgs = {
  data: DropdownInput;
  id: Scalars['ID'];
  type: FormType;
};


export type MutationUpdateEmailTemplateArgs = {
  data: EmailNotificationTemplateInput;
  id: Scalars['ID'];
  objectId: Scalars['ID'];
  objectType: EmailTemplateType;
};


export type MutationUpdateEvaluationFormConfigurationArgs = {
  data?: InputMaybe<EvaluationFormConfigurationInput>;
  id: Scalars['ID'];
};


export type MutationUpdateInvoiceArgs = {
  data: BrandInvoiceInput;
  id: Scalars['ID'];
};


export type MutationUpdateLicenseAgreementArgs = {
  data: LicenseAgreementInput;
  id: Scalars['ID'];
};


export type MutationUpdateLicenseTypeArgs = {
  data?: InputMaybe<LicenseTypeInput>;
  id: Scalars['ID'];
};


export type MutationUpdateLicenseeCompanyArgs = {
  data: CompanyInput;
  id: Scalars['ID'];
};


export type MutationUpdateModuleArgs = {
  data?: InputMaybe<LearningModuleInput>;
  id: Scalars['ID'];
};


export type MutationUpdatePercentRatingFieldArgs = {
  data: PercentRatingInput;
  id: Scalars['ID'];
  type: FormType;
};


export type MutationUpdateRatingFieldArgs = {
  data: RatingInput;
  id: Scalars['ID'];
  type: FormType;
};


export type MutationUpdateRegistrationFormConfigurationArgs = {
  data?: InputMaybe<RegistrationFormConfigurationInput>;
  id: Scalars['ID'];
};


export type MutationUpdateRenewalPeriodArgs = {
  id: Scalars['ID'];
  period: Scalars['Int'];
};


export type MutationUpdateSectionArgs = {
  data: SectionInput;
  id: Scalars['ID'];
  type: FormType;
};


export type MutationUpdateStarRatingFieldArgs = {
  data: StarRatingInput;
  id: Scalars['ID'];
  type: FormType;
};


export type MutationUpdateTextAreaFieldArgs = {
  data: TextAreaInput;
  id: Scalars['ID'];
  type: FormType;
};


export type MutationUpdateTextFieldArgs = {
  data: TextInput;
  id: Scalars['ID'];
  type: FormType;
};


export type MutationUseAccountArgs = {
  accountId: Scalars['ID'];
};

export type OrderAmountLine = {
  readonly __typename: 'OrderAmountLine';
  readonly amount: Money;
  readonly caption: Scalars['String'];
  readonly important: Scalars['Boolean'];
  readonly subLines: ReadonlyArray<OrderAmountSubLine>;
};

export type OrderAmountSubLine = {
  readonly __typename: 'OrderAmountSubLine';
  readonly amount: Money;
  readonly caption: Scalars['String'];
  readonly important: Scalars['Boolean'];
};

export type OrdinaryField = Field & {
  readonly __typename: 'OrdinaryField';
  readonly id: Scalars['ID'];
  readonly label: Scalars['String'];
  readonly labels: ReadonlyArray<TranslatedWord>;
  readonly sectionId: Scalars['ID'];
  readonly type: FieldType;
};

export type ParentLicense = {
  readonly __typename: 'ParentLicense';
  readonly active: Scalars['Boolean'];
  readonly amount: Scalars['Float'];
  readonly category?: Maybe<Category>;
  readonly continuousRenewal: Scalars['Boolean'];
  readonly currency: Currency;
  readonly expired: Scalars['Boolean'];
  readonly expiresAt: Scalars['Date'];
  readonly expiresIn: Scalars['Int'];
  readonly id: Scalars['ID'];
  readonly seats: Scalars['Int'];
  readonly subLicenses: ReadonlyArray<License>;
  readonly type?: Maybe<LicenseType>;
  readonly typeId: Scalars['ID'];
};

export enum PaymentMethod {
  ByCard = 'ByCard',
  ByInvoice = 'ByInvoice'
}

export type PercentRatingInput = {
  readonly label: Scalars['String'];
  readonly labels: ReadonlyArray<TranslatedWordInput>;
  readonly sectionId: Scalars['String'];
};

export enum PlatformEventKind {
  Attendee_Registered = 'Attendee_Registered',
  Certificate_Generated = 'Certificate_Generated',
  Evaluation_Created = 'Evaluation_Created',
  Event_Finished = 'Event_Finished',
  Event_Started = 'Event_Started',
  License_Expired = 'License_Expired'
}

export type PossibleField = DropdownField | OrdinaryField;

export enum PrivatePublicStatus {
  OnlyPrivate = 'OnlyPrivate',
  OnlyPublic = 'OnlyPublic',
  PrivatePublic = 'PrivatePublic'
}

export type Query = {
  readonly __typename: 'Query';
  readonly account: Account;
  readonly attendees?: Maybe<AttendeeFeed>;
  readonly badges: ReadonlyArray<Badge>;
  readonly brandEvents: EventsFeed;
  readonly categories: ReadonlyArray<Maybe<Category>>;
  readonly categoryAccess: CategoryAccess;
  readonly configuration: Configuration;
  readonly contact?: Maybe<Contact>;
  readonly contacts?: Maybe<ContactFeed>;
  readonly dashboardNotifications: ReadonlyArray<DashboardNotification>;
  readonly defaultEvaluationFormConfiguration?: Maybe<EvaluationFormConfiguration>;
  readonly emailTemplates: ReadonlyArray<EmailNotificationTemplate>;
  readonly evaluationFormConfiguration?: Maybe<EvaluationFormConfiguration>;
  readonly evaluationFormSectionConfigurations: ReadonlyArray<Maybe<SectionConfiguration>>;
  readonly evaluations?: Maybe<EvaluationFeed>;
  readonly eventTypeAccesses: ReadonlyArray<EventTypeAccess>;
  readonly eventTypes: ReadonlyArray<EventType>;
  readonly events: EventsFeed;
  readonly expiringLicenses: LicenseFeed;
  readonly exportEventConfig?: Maybe<ReportConfig>;
  readonly getAccount?: Maybe<Account>;
  readonly getAccountsFeed?: Maybe<AccountsFeed>;
  readonly getAttendee?: Maybe<Attendee>;
  readonly getCustomFields?: Maybe<ReadonlyArray<Maybe<CustomField>>>;
  readonly getEventTicketTypes?: Maybe<ReadonlyArray<Maybe<TicketType>>>;
  readonly invoiceStatistics?: Maybe<BrandInvoiceStatistics>;
  readonly invoices?: Maybe<InvoiceFeed>;
  readonly licenseAgreement?: Maybe<LicenseAgreement>;
  readonly licenseType?: Maybe<LicenseType>;
  readonly licenseTypes: ReadonlyArray<LicenseType>;
  readonly licenseTypesByBrand: ReadonlyArray<LicenseType>;
  readonly licensee?: Maybe<Licensee>;
  readonly licenseeBadges: ReadonlyArray<Badge>;
  readonly licenseeLicenses: ReadonlyArray<License>;
  readonly licenseeManagers: ReadonlyArray<Manager>;
  readonly licenseeSublicenses: ReadonlyArray<License>;
  readonly licensees?: Maybe<LicenseesFeed>;
  readonly me: User;
  readonly modules: ReadonlyArray<LearningModule>;
  readonly monthlyPaidStatistics: ReadonlyArray<BrandMonthlyPaidStatistics>;
  readonly notification: DashboardNotification;
  readonly parentLicense: ParentLicense;
  readonly parentLicenses: ReadonlyArray<ParentLicense>;
  readonly pastEvents?: Maybe<EventsFeed>;
  readonly recentEvents?: Maybe<ReadonlyArray<Maybe<Event>>>;
  readonly registrationFormConfiguration?: Maybe<RegistrationFormConfiguration>;
  readonly registrationFormSectionConfigurations: ReadonlyArray<Maybe<SectionConfiguration>>;
  readonly reportConfig?: Maybe<ReportConfig>;
  readonly trainers: ReadonlyArray<Trainer>;
  readonly unpaidInvoices?: Maybe<EventInvoiceFeed>;
};


export type QueryAttendeesArgs = {
  count?: InputMaybe<Scalars['Int']>;
  createdLessThan?: InputMaybe<Scalars['String']>;
  filterByTypeId?: InputMaybe<Scalars['String']>;
  orderBy: AttendeeOrderByInput;
  searchBy?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryBrandEventsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  count: Scalars['Int'];
  endEndsOn?: InputMaybe<Scalars['DateTime']>;
  orderBy?: InputMaybe<EventOrderByInput>;
  public?: InputMaybe<Scalars['Boolean']>;
  searchBy?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  startBeginsOn?: InputMaybe<Scalars['DateTime']>;
  trainerId?: InputMaybe<Scalars['ID']>;
  typeId?: InputMaybe<Scalars['ID']>;
};


export type QueryCategoryAccessArgs = {
  licenseeId: Scalars['ID'];
};


export type QueryContactArgs = {
  contactId: Scalars['ID'];
};


export type QueryContactsArgs = {
  count: Scalars['Int'];
  orderBy: ContactOrderByInput;
  searchBy?: InputMaybe<Scalars['String']>;
  skip: Scalars['Int'];
};


export type QueryEmailTemplatesArgs = {
  objectId: Scalars['ID'];
  objectType: EmailTemplateType;
};


export type QueryEvaluationFormConfigurationArgs = {
  id: Scalars['ID'];
};


export type QueryEvaluationsArgs = {
  count?: InputMaybe<Scalars['Int']>;
  createdLessThan?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<EvaluationOrderByInput>;
  searchBy?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryEventTypeAccessesArgs = {
  licenseeId: Scalars['ID'];
};


export type QueryEventsArgs = {
  count: Scalars['Int'];
  endBeginsOn?: InputMaybe<Scalars['DateTime']>;
  endEndsOn?: InputMaybe<Scalars['DateTime']>;
  orderBy?: InputMaybe<EventOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  startBeginsOn?: InputMaybe<Scalars['DateTime']>;
  startEndsOn?: InputMaybe<Scalars['DateTime']>;
};


export type QueryExpiringLicensesArgs = {
  count?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAccountArgs = {
  accountId: Scalars['ID'];
};


export type QueryGetAccountsFeedArgs = {
  filterByTypes?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  orderBy?: InputMaybe<AccountOrderByInput>;
  searchBy?: InputMaybe<Scalars['String']>;
  skip: Scalars['Int'];
};


export type QueryGetAttendeeArgs = {
  attendeeId: Scalars['ID'];
};


export type QueryGetEventTicketTypesArgs = {
  eventId?: InputMaybe<Scalars['ID']>;
};


export type QueryInvoicesArgs = {
  count: Scalars['Int'];
  filterByState?: InputMaybe<Scalars['String']>;
  orderBy: InvoiceOrderByInput;
  searchBy?: InputMaybe<Scalars['String']>;
  skip: Scalars['Int'];
};


export type QueryLicenseAgreementArgs = {
  id: Scalars['ID'];
};


export type QueryLicenseTypeArgs = {
  id: Scalars['ID'];
};


export type QueryLicenseTypesByBrandArgs = {
  brandId: Scalars['ID'];
};


export type QueryLicenseeArgs = {
  licenseeId: Scalars['ID'];
};


export type QueryLicenseeBadgesArgs = {
  licenseeId: Scalars['ID'];
};


export type QueryLicenseeLicensesArgs = {
  licenseeId: Scalars['ID'];
};


export type QueryLicenseeManagersArgs = {
  licenseeId: Scalars['ID'];
};


export type QueryLicenseeSublicensesArgs = {
  licenseeId: Scalars['ID'];
};


export type QueryLicenseesArgs = {
  count: Scalars['Int'];
  filterByStatus?: InputMaybe<Scalars['String']>;
  filterByType?: InputMaybe<Scalars['String']>;
  orderBy: LicenseeOrderByInput;
  searchBy?: InputMaybe<Scalars['String']>;
  skip: Scalars['Int'];
};


export type QueryNotificationArgs = {
  id: Scalars['ID'];
};


export type QueryParentLicenseArgs = {
  id: Scalars['ID'];
};


export type QueryPastEventsArgs = {
  count?: InputMaybe<Scalars['Int']>;
  endedLessThan?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<EventOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRecentEventsArgs = {
  accountId: Scalars['ID'];
  count: Scalars['Int'];
};


export type QueryRegistrationFormConfigurationArgs = {
  id: Scalars['ID'];
};


export type QueryTrainersArgs = {
  onlyActive?: InputMaybe<Scalars['Boolean']>;
};


export type QueryUnpaidInvoicesArgs = {
  count?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type RatingInput = {
  readonly label: Scalars['String'];
  readonly labels: ReadonlyArray<TranslatedWordInput>;
  readonly sectionId: Scalars['String'];
};

export type RegistrationFormConfiguration = {
  readonly __typename: 'RegistrationFormConfiguration';
  readonly editingRights: EditingRights;
  readonly id: Scalars['ID'];
  readonly instructions?: Maybe<Scalars['String']>;
  readonly rules: FormConfigurationRules;
  readonly sections: ReadonlyArray<SectionSkeleton>;
};

export type RegistrationFormConfigurationInput = {
  readonly instructions?: InputMaybe<Scalars['String']>;
  readonly rules: FormConfigurationRulesInput;
  readonly sections: ReadonlyArray<SectionSkeletonInput>;
};

export type Reply = {
  readonly __typename: 'Reply';
  readonly answer?: Maybe<Scalars['String']>;
  readonly fieldId: Scalars['ID'];
  readonly label: Scalars['String'];
  readonly replyType: Scalars['String'];
};

export type ReportConfig = {
  readonly __typename: 'ReportConfig';
  readonly attendee: ReadonlyArray<ReportConfigField>;
  readonly evaluation: ReadonlyArray<ReportConfigField>;
  readonly event: ReadonlyArray<ReportConfigField>;
  readonly invoice: ReadonlyArray<ReportConfigField>;
};

export type ReportConfigField = {
  readonly __typename: 'ReportConfigField';
  readonly id: Scalars['ID'];
  readonly selected: Scalars['Boolean'];
  readonly title: Scalars['String'];
};

export enum ScheduleStatus {
  Finished = 'Finished',
  InFuture = 'InFuture',
  InProgress = 'InProgress'
}

export type SectionConfiguration = {
  readonly __typename: 'SectionConfiguration';
  readonly editable: Scalars['Boolean'];
  readonly fields: ReadonlyArray<FieldConfiguration>;
  readonly id: Scalars['ID'];
  readonly names: ReadonlyArray<TranslatedWord>;
  readonly sortableFields: Scalars['Boolean'];
};

export type SectionInput = {
  readonly names: ReadonlyArray<TranslatedWordInput>;
};

export type SectionSkeleton = {
  readonly __typename: 'SectionSkeleton';
  readonly fields: ReadonlyArray<FieldSkeleton>;
  readonly id: Scalars['ID'];
};

export type SectionSkeletonInput = {
  readonly fields: ReadonlyArray<FieldSkeletonInput>;
  readonly id: Scalars['ID'];
};

export type SendingConditions = {
  readonly __typename: 'SendingConditions';
  readonly event: PlatformEventKind;
  readonly when: TimeCondition;
};

export type SendingConditionsInput = {
  readonly event: PlatformEventKind;
  readonly when: TimeConditionInput;
};

export type StarRatingInput = {
  readonly label: Scalars['String'];
  readonly labels: ReadonlyArray<TranslatedWordInput>;
  readonly sectionId: Scalars['String'];
};

export type SubscriptionPeriod = {
  readonly __typename: 'SubscriptionPeriod';
  readonly end: Scalars['Date'];
  readonly excludeFromExperience: Scalars['Boolean'];
  readonly start: Scalars['Date'];
};

export type TextAreaInput = {
  readonly label: Scalars['String'];
  readonly labels: ReadonlyArray<TranslatedWordInput>;
  readonly sectionId: Scalars['String'];
};

export type TextInput = {
  readonly label: Scalars['String'];
  readonly labels: ReadonlyArray<TranslatedWordInput>;
  readonly sectionId: Scalars['String'];
};

export type TicketType = {
  readonly __typename: 'TicketType';
  readonly amount: Scalars['Float'];
  readonly currency: Currency;
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
};

export type TimeCondition = {
  readonly __typename: 'TimeCondition';
  readonly beforeAfter: BeforeAfter;
  readonly unitType: TimeUnit;
  readonly units: Scalars['Int'];
};

export type TimeConditionInput = {
  readonly beforeAfter: BeforeAfter;
  readonly unitType: TimeUnit;
  readonly units: Scalars['Int'];
};

export enum TimeUnit {
  Day = 'Day',
  Hour = 'Hour',
  Month = 'Month'
}

export type Trainer = {
  readonly __typename: 'Trainer';
  readonly address: Address;
  readonly bio?: Maybe<Scalars['String']>;
  readonly email: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly phone?: Maybe<Scalars['String']>;
  readonly photo?: Maybe<Scalars['String']>;
};

export type TrainerAccount = Account & {
  readonly __typename: 'TrainerAccount';
  readonly active?: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['ID'];
  readonly image: Scalars['String'];
  readonly isCertified: Scalars['Boolean'];
  readonly isTrial?: Maybe<Scalars['Boolean']>;
  readonly name: Scalars['String'];
  readonly readonly?: Maybe<Scalars['Boolean']>;
  readonly trial?: Maybe<AccountTrialSettings>;
};

export type TranslatedOptionInput = {
  readonly language: Scalars['String'];
  readonly options: ReadonlyArray<Scalars['String']>;
};

export type TranslatedOptions = {
  readonly __typename: 'TranslatedOptions';
  readonly language: Scalars['String'];
  readonly translations: ReadonlyArray<Scalars['String']>;
};

export type TranslatedWord = {
  readonly __typename: 'TranslatedWord';
  readonly language: Scalars['String'];
  readonly translation: Scalars['String'];
};

export type TranslatedWordInput = {
  readonly language: Scalars['String'];
  readonly translation: Scalars['String'];
};

export type User = {
  readonly __typename: 'User';
  readonly accounts?: Maybe<ReadonlyArray<Account>>;
  readonly email?: Maybe<Scalars['String']>;
  readonly firstName?: Maybe<Scalars['String']>;
  readonly id?: Maybe<Scalars['ID']>;
  readonly isAdmin?: Maybe<Scalars['Boolean']>;
  readonly lastName?: Maybe<Scalars['String']>;
};
